/**
 * The `?redirect=` parameter of the login page: where to go after signing in
 * (set when the user was signed out for inactivity, lib/idleSession).
 *
 * Only same-origin, in-app paths are accepted — never another origin
 * (`//host`, `/\host`, `https:`), and never the public auth pages themselves —
 * so the parameter cannot be used as an open redirect.
 */
const AUTH_PATHS = ['/login', '/register', '/reset-password', '/account-pending'];

export function safeRedirectPath(value: string | null | undefined): string | null {
  if (typeof value !== 'string' || value === '' || value.length > 2048) return null;
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null;
  // Control characters (incl. tab/newline, which URL parsing strips) are never part of an app path.
  if (Array.from(value).some((ch) => ch.charCodeAt(0) < 0x20 || ch.charCodeAt(0) === 0x7f)) return null;
  let url: URL;
  try {
    url = new URL(value, 'http://reefguide.invalid');
  } catch {
    return null;
  }
  if (url.origin !== 'http://reefguide.invalid') return null;
  if (AUTH_PATHS.some((p) => url.pathname === p || url.pathname.startsWith(`${p}/`))) return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

/** `/login?redirect=<path>` for a safe path, else `/login`. */
export function loginPathWithRedirect(path: string): string {
  const safe = safeRedirectPath(path);
  return safe === null ? '/login' : `/login?redirect=${encodeURIComponent(safe)}`;
}
